module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buettikon-3ff376c050bec4e3f187e0fddf47cd0f.svg";